import React from 'react'
const ParticipantList = ctx => {
  return <ul className="panel">
    { ctx.participants.map((participant, i) => {
      return <li className="panel-block" key={`participant-${participant.displayName}-${i}`}>
        { participant.displayName }
      </li>
    })}
    { ctx.participants.length < ctx.totalParticipants ? 
      <li className="panel-block">
        ...
      </li>

        : null }
  </ul>
}

export default ParticipantList
